
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sk-club",
      function () {
        return require("private-next-pages/sk-club.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sk-club"])
      });
    }
  